import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || '/api';

export const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// URL endpoints
export const createShortUrl = (data) => api.post('/urls', data);
export const getUrl = (shortCode) => api.get(`/urls/${shortCode}`);
export const listUrls = (page = 1, limit = 20) => api.get(`/urls?page=${page}&limit=${limit}`);
export const deleteUrl = (shortCode) => api.delete(`/urls/${shortCode}`);

// Analytics endpoints
export const getAnalytics = (shortCode) => api.get(`/analytics/${shortCode}`);
export const getGlobalAnalytics = () => api.get('/analytics');
